module.exports = __webpack_public_path__ + "7d3226a677d492c2c444484174d82a67.pdf";